module.exports = "/_next/static/images/advance-logo-blue-e3dd70a7c7952ebe1f6e0d060d735040.png";